import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  documentTypes: [],
  attachOptions:[],
  invoiceDocumentTypes: [],
  attachments:[],
  attachmentSize:null,
  totalAttachments:0,
  selectAllField: false,
  selectedAttachments: [],

  preapprovedInvoiceAttachments: [],
  preapprovedInvoiceTotalAttachments: 0,
  preapprovedInvoiceSelectAllField: false,
  preapprovedInvoiceSelectedAttachments: [],

  prepaymentDocumentTypes: [],
  prepaymentAttachments: [],
  prepaymentTotalAttachments: 0,
  selectAllFieldPrepayment: false,
  selectedPrepaymentAttachments: [],
  profileDocumentTypes:[],
  profileDocuments: [],
  processDocuments:[],
  PODocumentTypes: [],
  POAttachments: [],
  totalPOAttachments: 0,
  selectAllFieldPO: false,
  selectedPOAttachments: []

}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
